import CoverSection from "../components/common/sections/CoverSection";
import FeatureSection from "../components/common/sections/FeatureSection";
import config from "../config";

const Faq = ({t}) => {
    const title = t("pages.about_us.submenus.faq.title", { returnObjects: true });
    const feature_section_1 = t("pages.about_us.submenus.faq.feature_section_1", { returnObjects: true });
    const feature_section_2 = t("pages.about_us.submenus.faq.feature_section_2", { returnObjects: true });


    return (
      <div className="content">
        <CoverSection title={title} backgroundImage={config.globalCover} />
        <FeatureSection
          title={feature_section_1.title}
          items={feature_section_1.items}
          useAccordion={true}
        />
        <FeatureSection
          title={feature_section_2.title}
          items={feature_section_2.items}
          useAccordion={true}
        />
      </div>
    );
}

export default Faq;